import {Provider} from './provider/Provider';

const ControllerService = {
    methodsList: ({ sync = false }) => {
        return Provider({
            sync,
            methodName: 'Api/Controller/MethodsList',
        });
    },
}

export default ControllerService